import { storage } from '@/services/storage'
import Marketing from '@/views/marketing'
import Integrations from '@/views/marketing/integrations'
import Erp from '@/views/marketing/integrations/erp'
import ErpAddIntegration from '@/views/marketing/integrations/erp/add'
import ErpManagerIntegration from '@/views/marketing/integrations/erp/erp-manager-integration'
import ErpProductIntegrationForm from '@/views/marketing/integrations/erp/product-integration-form'
import ErpProducts from '@/views/marketing/integrations/erp/products'
import ErpProposalMapsFields from '@/views/marketing/integrations/erp/proposal-maps-fiels'
import Facebook from '@/views/marketing/integrations/facebook'
import FormTracking from '@/views/marketing/integrations/form-tracker'
import MarketingQueues from '@/views/marketing/queues'
import MarketingQueuesAdd from '@/views/marketing/queues/add'
import MarketingQueuesList from '@/views/marketing/queues/list'

var routes = [
	{
		path: '/marketing',
		name: 'marketing',
		component: Marketing,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Marketing',
			protect: true,
			rules: {
				groups: [
					'admin',
					'collaborator',
				],
				redirect: { name: 'errors.not.unauthorized' },
			}
		},
		children: [
			{
				path: 'integracoes',
				name: 'marketing.integrations',
				component: Integrations,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Integrações',
					protect: true,
					rules: {
						groups: [
							'admin',
							'collaborator',
						],
						redirect: { path: 'errors.not.unauthorized' }
					}
				},
				children: [
					{
						path: 'facebook',
						name: 'marketing.integrations.facebook',
						component: Facebook,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Integração Facebook',
							protect: true,
							rules: {
								groups: [
									'admin',
									'collaborator',
									'dinamic'
								],
							}
						},
					},
					{
						path: 'formtracker',
						name: 'marketing.integrations.formtracker',
						component: FormTracking,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Form Tracker',
							protect: true,
							rules: {
								groups: [
									'admin',
									'collaborator',
									'dinamic'
								],
								redirect: '/app/trackerForms/pagina/list'
							}
						},
					},
					{
						path: 'erp',
						name: 'marketing.integrations.erp',
						component: Erp,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Marketing',
							protect: true,
							rules: {
								groups: [
									'admin',
									'collaborator',
								],
								redirect: {name: 'errors.not.unauthorized'}
							}
						},
						children: [
							{
								path: 'empreendimentos',
								name: 'marketing.integrations.erp.products',
								component: ErpProducts,
								props: true,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Empreendimentos Integrados',
									protect: true,
									rules: {
										groups: [
											'admin',
											'collaborator',
										],
										redirect: {name: 'errors.not.unauthorized'}
									}
								},
							},
							{
								path: 'integracoes',
								name: 'marketing.integrations.erp.integrations',
								component: ErpManagerIntegration,
								props: true,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Empreendimentos Integrados',
									protect: true,
									rules: {
										groups: [
											'admin',
											'collaborator',
										],
										redirect: {name: 'errors.not.unauthorized'}
									}
								},
							},
							{
								path: 'adicionar/:id?',
								name: 'marketing.integrations.erp.add',
								component: ErpAddIntegration,
								props: true,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Adicionar Integrações',
									protect: true,
									rules: {
										groups: [
											'admin',
											'collaborator',
										],
										redirect: {name: 'errors.not.unauthorized'}
									}
								},
							},
							{
								path: 'dados-disponibilidade/:id?',
								name: 'marketing.integrations.erp.availability',
								component: ErpProductIntegrationForm,
								props: true,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Dados da Disponibilidade Integrações',
									protect: true,
									rules: {
										groups: [
											'admin',
											'collaborator',
										],
										redirect: {name: 'errors.not.unauthorized'}
									}
								},
							},
							{
								path: 'mapear-campos-proposta/:id?',
								name: 'marketing.integrations.erp.map_proposal',
								component: ErpProposalMapsFields,
								props: true,
								meta: {
									title: (storage.get('client_name') || 'Facilita') + ' - Mapear campos de Integrações',
									protect: true,
									rules: {
										groups: [
											'admin',
											'collaborator',
										],
										redirect: {name: 'errors.not.unauthorized'}
									}
								},
							}
						],
					},
				]
			},
			{
				path: 'filas',
				name: 'marketing.queues',
				component: MarketingQueues,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Filas',
					protect: true,
					permissions: {
						groups: ['broker', 'manager', 'supervisor'],
						redirect: {name: 'errors.not.unauthorized'}
					}
				},
				children: [
					{
						path: 'adicionar',
						name: 'marketing.queues.add',
						component: MarketingQueuesAdd,
						props: true,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Adicionar de Fila',
							protect: true,
							permissions: {
								groups: ['broker', 'manager', 'supervisor'],
								redirect: {name: 'errors.not.unauthorized'}
							}
						},
					},
					{
						path: 'configuracao/:id',
						name: 'marketing.queues.config',
						component: MarketingQueuesAdd,
						props: true,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Configuração de Fila',
							protect: true,
							permissions: {
								groups: ['broker', 'manager', 'supervisor'],
								redirect: {name: 'errors.not.unauthorized'}
							}
						},
					},
					{
						path: 'lista',
						name: 'marketing.queues.list',
						component: MarketingQueuesList,
						props: true,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Lista de Filas',
							protect: true,
							permissions: {
								groups: ['broker', 'manager', 'supervisor'],
								redirect: {name: 'errors.not.unauthorized'}
							}
						},
					}
				],
			},

		]
	},
]

export { routes }

